import * as logger from '@mamdev/navigator.frontend-logger'
import { login } from '../form'
import { showMessage } from '../message-box'
import { getMonitoringService } from '../util/monitoring'
import { requestPppLayer } from '../util/ppp'

export async function handleAbo(accessToken: string) {
  try {
    await requestPppLayer(accessToken)
  } catch (e) {
    logger.error('Error during PPP life cycle', e)
  }

  try {
    getMonitoringService()?.flush()
    login(accessToken)
  } catch (e) {
    showMessage()
    logger.error(e)
    return
  }
}
